<template>
  <page :name="title" :title="title" :state="[orderState, transfersState]">
    <template #breadcrumbs>
      <pf-breadcrumb-item v-if="ref.breadcrumb" :to="{ name: ref.route }">{{ ref.breadcrumb }}</pf-breadcrumb-item>
    </template>

    <template v-if="order">
      <payment-report
        :result="Number($pop(route.query.res))"
        :error="$pop(route.query.err)"
        :route="ref.route"
        :link="transfers?.length ? null : ref.backlink"
        :success="$t('Ordine confermato')"
        :message="confirmationMessage"
        :order="order"
      />

      <pf-page-section v-if="transfers?.length && order.stato == 'concluso'" class="transfers">
        <transfers-list :transfers="transfers" @update="transfersState.update()" />
      </pf-page-section>
    </template>

    <pf-page-section v-else>
      <pf-alert variant="danger" :title="$t('Errore: Ordine non trovato')" />
    </pf-page-section>
  </page>
</template>

<style>
.transfers {
  margin-top: 50px;
}
</style>

<script lang="ts" setup>
import PaymentReport from '../components/payment-report.vue';
import TransfersList from '@/components/transfers-list.vue';
import { asyncComputed } from '@common/asyncComputed';
import { TransferResource, OrdersResource } from '@/resources';
import { computed } from 'vue';
import { pop } from '@common/utils';
import { useRoute } from 'vue-router';
import { $t as _t } from '@/i18n';

const route = useRoute();

const { state: orderState, result: order } = asyncComputed(async() => {
  const id = pop(route.params.id);
  if (id) {
    return await new OrdersResource().get(id);
  }
  return null;
});

const { state: transfersState, result: transfers } = asyncComputed(async() => {
  const id = pop(route.params.id);
  if (id) {
    return await new TransferResource({id_ordine: id}).get();
  }
  return null;
});

const ref = computed(() => {
  const ref = {
    route: 'dashboard',
    backlink: _t('Vai alla dashboard'),
    breadcrumb: null as string | null,
  };

  const queryRef = pop(route.params.ref);

  if (!queryRef) {
    return ref;
  }

  ref.route = queryRef;

  if (ref.route == 'catalog') {
    ref.breadcrumb = _t('Listino');
    ref.backlink = _t('Torna al listino');
  } else if (ref.route == 'products') {
    ref.breadcrumb = _t('Products');
    ref.backlink = _t('Torna alla lista prodotti');
  }

  return ref;
});

const title = computed(() => order.value?.id ? _t(`Ordine #{id}`, {id: order.value.id}) : _t('Ordine'));

const confirmationMessage = computed(() => {
  return transfers.value?.length
    ? _t('Il tuo ordine è confermato e verrà elaborato al più presto. Per velocizzare le operazioni compila con i dati richiesti i form che trovi qui sotto.')
    : _t('Il tuo ordine è in elaborazione: riceverai a breve un contatto da parte dei nostri tecnici.');
});
</script>
